import { render, staticRenderFns } from "./ModalNewUser.vue?vue&type=template&id=1d4e645a&scoped=true"
import script from "./ModalNewUser.vue?vue&type=script&lang=js"
export * from "./ModalNewUser.vue?vue&type=script&lang=js"
import style0 from "./ModalNewUser.vue?vue&type=style&index=0&id=1d4e645a&prod&scoped=true&lang=css"
import style1 from "./ModalNewUser.vue?vue&type=style&index=1&id=1d4e645a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e645a",
  null
  
)

export default component.exports